import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PaymentMethodCode } from '../../../shared/enums/payment-method-code';
import { PublicPaymentMethodPropertyResponse } from './public-payment-method-property.response';
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicCartPaymentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: PaymentMethodCode;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonArrayMember(PublicPaymentMethodPropertyResponse)
  public readonly properties!: PublicPaymentMethodPropertyResponse[];

  @jsonMember(MultimediaResponse)
  public readonly previewFile?: Nillable<MultimediaResponse>;
}
